var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSus4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_853_3892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0948 65.4788C47.4636 65.4788 57.4905 55.3982 57.4905 42.963C57.4905 30.5279 47.4636 20.4473 35.0948 20.4473C22.7261 20.4473 12.6992 30.5279 12.6992 42.963C12.6992 55.3982 22.7261 65.4788 35.0948 65.4788Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0944 47.9049C37.9338 47.9049 40.2356 45.5908 40.2356 42.7361C40.2356 39.8815 37.9338 37.5674 35.0944 37.5674C32.2549 37.5674 29.9531 39.8815 29.9531 42.7361C29.9531 45.5908 32.2549 47.9049 35.0944 47.9049Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2271 38.5316L41.2215 32.6896C41.6729 31.8088 41.2625 30.7291 40.3417 30.3759C36.9631 29.0791 33.2278 29.0791 29.8492 30.3759C28.9285 30.7293 28.5179 31.809 28.9693 32.6896L31.9637 38.5316",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1953 47.5753L40.8514 53.0234C41.4027 53.8448 42.5416 54.0018 43.2925 53.36C46.0477 51.0048 47.8433 47.7118 48.3362 44.11C48.4706 43.1284 47.7263 42.2475 46.7411 42.2221L40.2063 42.0537",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9926 47.5753L29.3365 53.0234C28.7852 53.8448 27.6463 54.0018 26.8954 53.36C24.1402 51.0048 22.3446 47.7118 21.8516 44.11C21.7173 43.1284 22.4616 42.2475 23.4468 42.2221L29.9816 42.0537",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0355 27.8483C67.3328 32.39 68.627 37.5254 68.627 42.963C68.627 61.4824 53.6141 76.4952 35.0948 76.4952C16.5756 76.4952 1.5625 61.4822 1.5625 42.9628C1.5625 24.4435 16.5755 9.43066 35.0947 9.43066C42.1278 9.43066 48.6552 11.5958 54.0466 15.2961",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3231 56.334C35.7241 56.399 35.1127 56.4202 34.4922 56.3946",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9609 34.6074C47.1812 34.9557 47.3845 35.3159 47.5694 35.687",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2295 34.6074C23.0092 34.9557 22.8059 35.3159 22.6211 35.687",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4639 27.4571C73.0779 27.4571 78.4395 22.0954 78.4395 15.4815C78.4395 8.86753 73.0779 3.50586 66.4639 3.50586C59.8499 3.50586 54.4883 8.86753 54.4883 15.4815C54.4883 22.0954 59.8499 27.4571 66.4639 27.4571Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2669 12.6738L63.6523 18.2884",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2669 18.2884L63.6523 12.6738",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_853_3892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSus4);
export default __webpack_public_path__ + "static/media/sus4.841c58c062084ecccb5ff881e8321371.svg";
export { ForwardRef as ReactComponent };